/*
 * @Description: 实时定位驾驶舱 — A4「成员详情」数据 hook（详情卡用）
 */
import { useEffect, useRef, useState } from 'react'
import { useAppDispatch } from '../../../app/hooks'
import { fetchMemberDetail } from '../../../actions/locationCockpit'
import { isCockpitMockEnabled } from '../constants'
import { getMockMemberDetail } from '../mock/detail.mock'
import { CockpitEnvelope, MemberDetail } from '../types/cockpit.types'

export interface UseMemberDetailResult {
  detail: MemberDetail | null
}

/**
 * 拉取选中成员的详情（A4）。userId 为 null 时返回 null（不发请求）。
 * 由实时轨迹页根据选中成员调用，结果驱动地图详情卡的展示。
 *
 * @param groupId - 当前团队长 id
 * @param userId - 选中成员 userId；null 表示未选中
 */
export function useMemberDetail(
  groupId: string,
  userId: string | null
): UseMemberDetailResult {
  const dispatch = useAppDispatch()
  const isMock = isCockpitMockEnabled()
  const [detail, setDetail] = useState<MemberDetail | null>(null)
  const aliveRef = useRef(true)

  useEffect(() => {
    aliveRef.current = true

    if (!userId) {
      setDetail(null)
      return () => {
        aliveRef.current = false
      }
    }

    if (isMock) {
      setDetail(getMockMemberDetail(userId))
      return () => {
        aliveRef.current = false
      }
    }

    if (!groupId) {
      return () => {
        aliveRef.current = false
      }
    }

    dispatch(fetchMemberDetail({ groupId, userId }))
      .then((res: CockpitEnvelope<MemberDetail>) => {
        if (!aliveRef.current) return
        if (res && res.code === 200) {
          setDetail(res.data ?? null)
        }
      })
      .catch(() => {
        /* 详情拉取失败不弹错误，卡片不展示即可 */
      })

    return () => {
      aliveRef.current = false
    }
  }, [dispatch, groupId, userId, isMock])

  return { detail }
}
